import { Header } from '@mairistem/composants';
import _ from 'lodash';
import React from 'react';

import { ModalConfirm } from '@/components/Autre';
import { MODES_REGLEMENTS } from '@/constants';
import { formatMonetaire, getLibelleByCode } from '@/utils';
import ModalRepartitionNumeraire from './ModalRepartitionNumeraire';

const ModalGenerationBordereau = (props) => {
  const { loading, totalMode, montantTotal, onCancel, onConfirm, modeReglementActif } = props;

  const [repartitionNumeraire, setRepartitionNumeraire] = React.useState(null);

  const handleRepartitionSave = React.useCallback((montants) => {
    setRepartitionNumeraire(montants);
  }, []);

  const handleConfirm = React.useCallback(() => {
    if (modeReglementActif === MODES_REGLEMENTS.NUMERAIRE) {
      onConfirm(repartitionNumeraire);
    } else {
      onConfirm();
    }
  }, [modeReglementActif, onConfirm, repartitionNumeraire]);

  return (
    <>
      <ModalConfirm
        size="tiny"
        loading={loading}
        header="Génération du bordereau de remise"
        content={
          <Header as="h4">
            <Header.Content>
              <Header.Subheader>
                Le bordereau de remise{' '}
                {modeReglementActif !== MODES_REGLEMENTS.NUMERAIRE ? 'comprenant ' : ''}
                {modeReglementActif !== MODES_REGLEMENTS.NUMERAIRE ? (
                  <b>{`${totalMode} ${getLibelleByCode(modeReglementActif, totalMode > 1)} `}</b>
                ) : (
                  ''
                )}
                d&apos;un montant total de <b>{formatMonetaire(montantTotal, 2, true)}</b> va être
                généré.
              </Header.Subheader>
              <br />
              Êtes-vous sûr de vouloir effectuer cette action ?
            </Header.Content>
          </Header>
        }
        cancelText="Annuler"
        confirmText="Confirmer la génération"
        onCancel={onCancel}
        onConfirm={handleConfirm}
      />
      {modeReglementActif === MODES_REGLEMENTS.NUMERAIRE && _.isNil(repartitionNumeraire) && (
        <ModalRepartitionNumeraire
          montantTotalReglements={parseFloat(montantTotal)}
          onClose={() => setRepartitionNumeraire({})}
          onSave={handleRepartitionSave}
        />
      )}
    </>
  );
};

export default ModalGenerationBordereau;
